import { jsxs, jsx } from 'react/jsx-runtime';
import { LayoutGroup } from 'framer-motion';
import { useMemo } from 'react';
import { styled } from 'styled-components';
import { VirtualResourceTable } from './VirtualResourceTable.js';
import { CellContent } from './cellMap.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import RecapSummaryButton from '../../../../recap/components/RecapSummaryButton.js';

const VirtualResourceTableDivisions = ({ splitResourceGroups, layoutId, onInfiniteTrigger, resourcesTotalCount, containerWidth, disableItemPreviewContextMenu, colorLabels, onResourceClick }) => {
  const { dividersAndResources, extraTotalCount } = useMemo(() => {
    const result = [];
    let extraTotalCount2 = 0;
    if (splitResourceGroups.length == 1) {
      return {
        dividersAndResources: splitResourceGroups[0].resources,
        extraTotalCount: 0
      };
    }
    splitResourceGroups.forEach((group) => {
      extraTotalCount2 += 2;
      result.push({
        divider: true
      });
      result.push({
        divider: true,
        renderContent: () => {
          return /* @__PURE__ */ jsxs(DividerContent, {
            gap: 10,
            style: {
              height: 54,
              top: -7
            },
            children: [
              group.title && /* @__PURE__ */ jsx(DivisionTitle, {
                children: group.title
              }),
              group?.recap && /* @__PURE__ */ jsx(RecapSummaryButton, {
                ...group.recap
              })
            ]
          });
        }
      });
      result.push(...group.resources);
    });
    return {
      dividersAndResources: result,
      extraTotalCount: extraTotalCount2
    };
  }, [
    splitResourceGroups
  ]);
  if (dividersAndResources.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(LayoutGroup, {
    id: `${layoutId}--tableview`,
    children: /* @__PURE__ */ jsx(VirtualResourceTable, {
      totalResourcesCount: resourcesTotalCount + extraTotalCount,
      resources: dividersAndResources,
      onInfiniteTrigger,
      scrollYMargin: 0,
      minWidth: containerWidth,
      disableItemPreviewContextMenu,
      onResourceClick,
      colorLabels
    })
  });
};
const DivisionTitle = styled.div.withConfig({
  displayName: "VirtualResourceTableDivisions__DivisionTitle",
  componentId: "sc-aafd5020-0"
})([
  `font-weight:600;font-size:13px;color:`,
  `;opacity:0.7;padding-left:3.375rem;`
], cssVar["color-text-tertiary"]);
const DividerContent = styled(CellContent).withConfig({
  displayName: "VirtualResourceTableDivisions__DividerContent",
  componentId: "sc-aafd5020-1"
})([
  `width:100%;height:100%;border-right:1px solid `,
  `;background:`,
  `;`
], cssVar["color-border-primary"], cssVar["color-bg-secondary"]);

export { VirtualResourceTableDivisions };
//# sourceMappingURL=VirtualResourceTableDivisions.js.map
